import { APP_STORE_URL } from "@/lib/links";

// Badge oficial de Apple (descargado de marketingtools.apple.com, servido local).
// Variante negra con borde blanco → legible sobre el fondo #050505.
export const AppStoreBadge = ({ t, lang, className = "h-[52px]", anchorClassName = "inline-flex", testId = "app-store-badge" }) => (
  <a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label={t.appStore.badgeAlt}
    className={`${anchorClassName} shrink-0 rounded-xl transition-transform hover:scale-[1.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F7931A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505]`}
  >
    <img
      src={`/appstore/badge-${lang === "en" ? "en" : "es"}.svg`}
      alt={t.appStore.badgeAlt}
      className={`${className} w-auto`}
    />
  </a>
);
